module.exports = __webpack_public_path__ + "img/video.mp4";